import {
  CommonModule,
} from '@angular/common';
import {
  NgModule,
} from '@angular/core';
import {
  MatButtonModule,
} from '@angular/material/button';
import {
  OrderStoreModule,
} from '@des/store/order';
import {
  TrackEventsModule,
} from '@o3r/analytics';
import {
  LocalizationModule,
} from '@o3r/localization';
import {
  DeeplinkReturnURLModule,
} from '@refx/shared-services';
import {
  CustomBackToMmbPresComponent,
} from './custom-back-to-mmb-pres.component';

@NgModule({
  imports: [
    CommonModule,
    LocalizationModule,
    TrackEventsModule,
    MatButtonModule,
    OrderStoreModule,
    DeeplinkReturnURLModule],
  declarations: [CustomBackToMmbPresComponent],
  exports: [CustomBackToMmbPresComponent]
})
export class CustomBackToMmbPresModule {}
